import { useContext, useEffect } from 'react';

import { AuthContext } from 'context/AuthContext';
import { AuthService } from 'services/main';
import { getLocalAuthStorage } from 'utils/localStorage';
import { FiltersContext } from 'context/GlobalFiltersContext';
import { skeleton as initialHeadersFiltersState } from 'context/GlobalFiltersContext/initialState';
import { localStorageKeys } from 'constants/localStorage';
import { useCookies } from 'react-cookie';
import { removeHeaderFilterCookies } from 'utils/cookies';
import { URLS } from 'constants/urls';
import * as Sentry from '@sentry/react';
const logoutLegado = async empresa => {
  try {
    const response = await fetch(`${process.env.REACT_APP_LEGADO}/Security/LogoutHandler.ashx`, {
      method: 'POST',
      credentials: 'include',
    });

    const status = response.status;

    if (status >= 200 && status < 300) {
      Sentry.logger.info('[Logout] legado logout realizado com sucesso', {
        empresa: empresa || 'não especificada',
      });
    } else if (status >= 400 && status < 500) {
      console.error('[Logout] erro cliente legado:', status);
      Sentry.logger.error('[Logout] erro cliente legado', {
        status,
        responseText: await response.text(),
        empresa: empresa || 'não especificada',
      });
    } else if (status >= 500) {
      console.error('[Logout] erro servidor legado:', status);
      Sentry.logger.error('[Logout] erro servidor legado', {
        status,
        responseText: await response.text(),
        empresa: empresa || 'não especificada',
      });
    }
  } catch (error) {
    console.error('[Logout] falha na requisição legado:', error);
    Sentry.captureException(error, {
      tags: {
        context: 'Logout - legado logout',
        empresa: empresa || 'não especificada',
      },
    });
  }
};
const Logout = () => {
  const { setFiltersContext } = useContext(FiltersContext);
  const { setAuthContext } = useContext(AuthContext);
  let { token } = getLocalAuthStorage();
  const removeCookie = useCookies()[2];
  const cookie = useCookies()[0];
  useEffect(() => {
    Sentry.logger.info('[Logout] montou', {
      temAuthToken: !!cookie?.authToken,
      reason: new URLSearchParams(window.location.search).get('reason'),
      empresa_id: cookie?.companies?.id,
      empresa_name: cookie?.companies?.name,
    });
  }, [cookie?.authToken, cookie?.companies?.id, cookie?.companies?.name]);
  useEffect(() => {
    const logout = async () => {
      await AuthService.logout({ token });
    };
    if (cookie?.authToken) {
      logout()
        .then(async () => {
          localStorage.setItem('socket', null);
          localStorage.removeItem(localStorageKeys.permissionContext);
          removeHeaderFilterCookies(removeCookie);
          // Sem isso, os cookies de sessão seguem válidos após o "logout": qualquer chamada de
          // API no /login que caia em 401 dispara o refresh (axios-auth-refresh) usando esses
          // cookies e reautentica o usuário silenciosamente — o "logout joga pro login e entra
          // automaticamente" que este fix resolve.
          removeCookie('authToken', { path: '/', domain: URLS.cookieDomain });
          removeCookie('refreshToken', { path: '/', domain: URLS.cookieDomain });
          setFiltersContext(initialHeadersFiltersState);
          sessionStorage.removeItem('adsPopupOpenedAfterLogin');

          setAuthContext({
            statusCode: false,
            isAuthenticated: false,
            token: null,
            refreshToken: null,
            expiresIn: null,
            user: {
              name: null,
            },
          });
          if (process.env.REACT_APP_MODE !== 'local') {
            //window.location.href = `${process.env.REACT_APP_LEGADO}/security/signout.aspx`;
            await logoutLegado(cookie?.companies?.id);
            window.location.replace('/login');
          } else {
            const lastLoginRoute = cookie?.lastLoginRoute;
            removeCookie('lastLoginRoute', { path: '/', domain: URLS.cookieDomain });
            window.location.replace(lastLoginRoute || '/login');
          }
        })
        .catch(error => {
          console.error({ error });
          removeCookie('authToken', { path: '/', domain: URLS.cookieDomain });
          removeCookie('refreshToken', { path: '/', domain: URLS.cookieDomain });
          const appVersion = localStorage.getItem('app-version');
          const forceReset = localStorage.getItem('force-reset-v1');
          window.localStorage.clear();
          if (appVersion) localStorage.setItem('app-version', appVersion);
          if (forceReset) localStorage.setItem('force-reset-v1', forceReset);
        });
    } else {
      removeHeaderFilterCookies(removeCookie);
      removeCookie('authToken', { path: '/', domain: URLS.cookieDomain });
      removeCookie('refreshToken', { path: '/', domain: URLS.cookieDomain });
      setFiltersContext(initialHeadersFiltersState);
      sessionStorage.removeItem('adsPopupOpenedAfterLogin');

      setAuthContext({
        statusCode: false,
        isAuthenticated: false,
        token: null,
        refreshToken: null,
        expiresIn: null,
        user: {
          name: null,
        },
      });
      removeCookie('qrcodeFilters', { path: '/', domain: URLS.cookieDomain });
      removeCookie('openNewChamado', { path: '/', domain: URLS.cookieDomain });
      removeCookie('chamadoWoba', { path: '/', domain: URLS.cookieDomain });
      removeCookie('chamadosAccess', { path: '/', domain: URLS.cookieDomain });
      removeCookie('chamadoRoute', { path: '/', domain: URLS.cookieDomain });

      const appVersion = localStorage.getItem('app-version');
      const forceReset = localStorage.getItem('force-reset-v1');
      window.localStorage.clear();
      if (appVersion) localStorage.setItem('app-version', appVersion);
      if (forceReset) localStorage.setItem('force-reset-v1', forceReset);
      const lastLoginRoute = cookie?.lastLoginRoute;
      removeCookie('lastLoginRoute', { path: '/', domain: URLS.cookieDomain });
      window.location.replace(lastLoginRoute || '/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

export { Logout };
